import { firebase } from '../config/configureFirebase';
import store from '../store/store';

export const RequestPushMsg = (token, data) => {
    const {
        config
    } = firebase;

    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin ? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/send_notification`;

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            "token": token,
            ...data
        })
    })
        .then((response) => response.json())
        .then((response) => response.json())
        .then((responseData) => {
            if (responseData.error) {
                console.log("Push Notification Error:", responseData.error);
            } else {
                console.log("Push Notification Sent Successfully");
            }
        })
        .catch((error) => {
            console.log("Push Notification Network Error:", error);
        });
}